// @core/api/endpoints/authn/create_oauth2_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateOAuth2ProviderRequest,
  OAuth2ProviderResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Create OAuth2 provider
 * Configures a new external OAuth2 identity provider such as Google, GitHub, or Microsoft. Stores client credentials and endpoint URLs for the provider.
 */
export async function CreateOAuth2Provider(
  data: CreateOAuth2ProviderRequest,
  options?: RequestOptions
): Promise<OAuth2ProviderResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/providers`;
  const requestOptions = options;
  return client.post<OAuth2ProviderResponse>(requestPath, data, requestOptions);
}
